// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"1af8c8ee","186":"bf3c61aa","435":"fcf4a2b3","473":"9f68aa93","534":"a44040b8","645":"71b4ad4e","859":"5a3a4b8d","896":"423ecffa"}[chunkId] + ".chunk.js";
};